import {} from 'dotenv/config';

import { MuiThemeProvider } from '@material-ui/core/styles';
import MomentUtils from 'material-ui-pickers/utils/moment-utils';
import MuiPickersUtilsProvider from 'material-ui-pickers/utils/MuiPickersUtilsProvider';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from './modules/core/pages/App';
import './index.css';
import * as serviceWorker from './serviceWorker';
import { Provider as ReduxProvider}  from 'react-redux';
import  store from './modules/core/store/index'
import {isAuthenticated, login} from './modules/core/auth/identityAuth';
import history from './history/browserHistory';
import * as queryString from 'query-string';

import NxtPortTheme from './theme';

if(isAuthenticated()){
  const route = decodeURIComponent(queryString.parse(window.location.hash).state)
  history.push(route)
  ReactDOM.render(
    <MuiThemeProvider theme={NxtPortTheme}>
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <ReduxProvider store={store}>
          <App />
        </ReduxProvider>
      </MuiPickersUtilsProvider>
    </MuiThemeProvider>,
    document.getElementById('root') as HTMLElement
  );
}
else{
  login()
}

serviceWorker.unregister();



// WEBPACK FOOTER //
// ./src/index.tsx